import { postMessage } from '@hll/cashier-kit'

export function bigScreen () {
  postMessage({ action: 'resizeParent', width: 1144, height: 715 })
}
export function PSLScreen () {
  postMessage({ action: 'resizeParent', width: 480, height: 600 })
}
export function loadingScreen () {
  postMessage({ action: 'resizeParent', width: 480, height: 380 })
}
export function adyenScreen () {
  postMessage({ action: 'resizeParent', width: 480, height: 650 })
}
export function failureScreen () {
  postMessage({ action: 'resizeParent', width: 480, height: 510 })
}
export function tappayScreen () {
  postMessage({ action: 'resizeParent', width: 480, height: 465 })
}
export function wechatScreen () {
  postMessage({ action: 'resizeParent', width: 600, height: 554 })
}
